
import { defineComponent } from "vue";
import { useLayoutStore } from "@/stores/layoutStore";
export default defineComponent({
	setup() {
		const layoutStore = useLayoutStore();
		return {
			layoutStore
		};
	},
	name: "LayoutHandle",
	data() {
		return {
			handleActive: false
		};
	},
	props: {
		type: {
			type: String,
			default: "row"
		},
		handleIds: {
			type: Array,
			default: () => []
		}
	},
	methods: {
		resizePanel(payload: { panel1: number; panel2: number; type: string }) {
			this.layoutStore.RESIZE_PANEL(payload);
		},
		collapse(payload: { type: string; id: number; id2: number }) {
			this.layoutStore.COLLAPSE_PANEL(payload);
		},
		handleDown() {
			this.handleActive = true;
			const MOUSE_UP_LISTENER = () => {
				this.handleActive = false;
				window.removeEventListener("mouseup", MOUSE_UP_LISTENER);
				window.dispatchEvent(new Event("resize"));
			};
			window.addEventListener("mouseup", MOUSE_UP_LISTENER);
		}
	}
});
